const controllers = new Map();

export async function abortableFetch(key, url, options = {}) {
  if (controllers.has(key)) {
    controllers.get(key).abort();
  }

  const controller = new AbortController();
  controllers.set(key, controller);

  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
    });
    return response;
  } catch (err) {
    if (err.name === "AbortError") {
      console.log(`Request aborted for ${key}`);
      return null;
    }
    throw err;
  } finally {
    controllers.delete(key);
  }
}

export function abortRequest(key) {
  if (controllers.has(key)) {
    controllers.get(key).abort();
    controllers.delete(key);
  }
}
